import PropTypes from 'prop-types';
var DEPRECATED_APPEARANCES = ['danger', 'negative', 'positive', 'success', 'tertiary', 'warning'];
var deprecatedAppearance = validator => {
  return function (props, propName, componentName) {
    var value = props[propName];
    if (process.env.NODE_ENV !== 'production' && (DEPRECATED_APPEARANCES.indexOf(value) !== -1 || value === true)) {
      console.warn(value === true ? "@veneer/core: The property negative has been deprecated since 3.33.0." : ["@veneer/core: The value `".concat(value, "` supplied to `").concat(componentName, ".").concat(propName, "` was deprecated.")].join('\n'));
    }
    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }
    return validator(props, propName, componentName, ...rest);
  };
};
var propTypes = {
  appearance: deprecatedAppearance(PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'negative', 'warning', 'positive', 'success', 'danger', 'ghost'])),
  children: PropTypes.node,
  className: PropTypes.string,
  colorScheme: PropTypes.oneOf(['default', 'positive', 'negative', 'warning']),
  customStyle: PropTypes.any,
  disabled: PropTypes.bool,
  expanded: PropTypes.bool,
  forceActive: PropTypes.bool,
  id: PropTypes.string,
  leadingIcon: PropTypes.element,
  loading: PropTypes.bool,
  name: PropTypes.string,
  small: PropTypes.bool,
  trailingIcon: PropTypes.element,
  type: PropTypes.oneOf(['submit', 'reset', 'button'])
};
export default propTypes;